module.exports = __webpack_public_path__ + "static/media/folder-outline.388a02e6.svg";